import { Typography } from "@mui/material";
import type { JSX } from "react";
import type { GuidFilter, SelectOption } from "../../api/types/objectTypes";
import { emptyGuid } from "./objectFilterHelpers";

interface Props {
  fieldName: string;
  filter: GuidFilter;
  options?: SelectOption[];
  startLabel: string;
}

const ObjectGuidFilterDescription = ({ fieldName, filter, options, startLabel }: Props): JSX.Element => {
  const ids = filter.values?.length ? filter.values : filter.value && filter.value !== emptyGuid ? [filter.value] : [];
  const labels = ids.map((id) => options?.find((option) => option.value === id)?.label ?? id).join(", ");
  return (
    <Typography>
      {startLabel} <strong>{fieldName}</strong> is one of <strong>{labels}</strong>
    </Typography>
  );
};

export default ObjectGuidFilterDescription;
